var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Carousel',{staticClass:"productCarousel",attrs:{"autoplay":true}},_vm._l((_vm.items),function(item){return _c('Slide',{key:item.id},[_c('ListItem',{attrs:{"carousel":true,"item":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }